import { LOGIKSPARK_BRANDING_BASE_URL } from '../../app/axios/const'

// Fixed platform brand assets for the public /signup flow, served anonymously from the branding blob
// container's reserved `platform/` prefix (uploaded by INFRA — see LogikSpark-INFRA stack/main.tf,
// azurerm_storage_blob.platform_*). These are platform-level and identical across tenants; per-tenant
// logos arrive instead via the branding API's LogoUrl.

// Tolerate a base URL configured with or without a trailing slash (it's interpolated, not handed to
// axios as a baseURL, so the separator isn't added for us). An empty base stays empty -> relative URLs
// that simply don't resolve, which is the intended non-fatal fallback when the env var is unset.
const base =
  LOGIKSPARK_BRANDING_BASE_URL && !LOGIKSPARK_BRANDING_BASE_URL.endsWith('/')
    ? `${LOGIKSPARK_BRANDING_BASE_URL}/`
    : LOGIKSPARK_BRANDING_BASE_URL

export const PLATFORM_LOGO_URL = `${base}platform/logikspark-two-colour.png`
export const PLATFORM_BACKGROUND_URL = `${base}platform/login-background.png`
